import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const ContentMasteryTestRepeatRateSummary = (props) => (
  <KpiSummary
    title="Audio listening difficulty"
    previousValue={props.previousValue}
    currentValue={props.currentValue}
    formatter={props.formatter}
    isLoading={props.isLoading}
  />
);

ContentMasteryTestRepeatRateSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

ContentMasteryTestRepeatRateSummary.defaultProps = {
  isLoading: false,
};

export default ContentMasteryTestRepeatRateSummary;
